import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import LovejoyContent from "./LovejoyCouplingContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route
            path="/suppliers/lovejoy/couplings"
            component={LovejoyContent}
          />
          <Route path="/suppliers/lovejoy">
            <Redirect to="/suppliers/lovejoy/couplings" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
